import * as types from "./types";

export const getAllPackagesRequest = () => ({
  type: types.GET_ALL_PACKAGES_REQUEST
});

export const getAllPackagesResponse = (payload) => ({
  type: types.GET_ALL_PACKAGES_RESPONSE,
  payload
});

export const addNewPackageRequest = (payload) => ({
  type: types.ADD_NEW_PACKAGE_REQUEST,
  payload
});

export const getSinglePackageRequest = (payload) => ({
  type: types.GET_SINGLE_PACKAGE_REQUEST,
  payload
});

export const getSinglePackageResponse = (payload) => ({
  type: types.GET_SINGLE_PACKAGE_RESPONSE,
  payload
});

export const editPackageRequest = (payload) => ({
  type: types.EDIT_PACKAGE_REQUEST,
  payload
});

export const editPackageResponse = (payload) => ({
  type: types.EDIT_PACKAGE_RESPONSE,
  payload
});

export const deletePackageRequest = (payload) => ({
  type: types.DELETE_PACKAGE_REQUEST,
  payload
});
